import { useCallback } from "react";
import memoizeOne from "memoize-one";

const useMemoizedSelector = (selector) =>
	useCallback(memoizeOne(selector), []);

export default useMemoizedSelector;
